export default {
  SET_INACTIVE_CTX_LOCK(state, hasInactiveContextLock) {
    state.hasInactiveContextLock = hasInactiveContextLock;
  }
};
